import React from 'react';
import GlassView from './GlassView'
import OldValuesHeader from '../../oldValues/OldValuesHeader';

let EyeGlassPrescription = props => {
  const { fieldsValues, template, previousExams, fieldKey, overviewName, examId } = props;

  const renderPrescriptions = (values) => (values || []).map((eyeGlass, index) => (
    <div className="col-12 py-4" key={eyeGlass.id || index}>
      <div><span>Eyeglass #{index + 1}</span></div>
      <GlassView
        fieldsValues={eyeGlass}
        template={template.eye_glasses[0]}
      />
    </div>
  ));

  return (
    <>
      {fieldsValues && <div className="row">{renderPrescriptions(fieldsValues)}</div>}
      {previousExams
        ?.filter(item => item.id !== examId)
        .flatMap(prevExam => {
          const values = prevExam?.[fieldKey] || [];
          return values.map((eyeGlass, index) => (
            <div className="col-12 border rounded mb-4 px-0" key={`${prevExam.id}-${eyeGlass.id || index}`}>
              <div className="row mx-0">
                <OldValuesHeader
                  prevExam={prevExam}
                  overviewName={overviewName}
                  examId={examId}
                  importIds={eyeGlass.id ? [eyeGlass.id] : []}
                />
                <div className="col-12 py-4">
                  <div><span>Eyeglass #{index + 1}</span></div>
                  <GlassView
                    fieldsValues={eyeGlass}
                    template={template.eye_glasses[0]}
                  />
                </div>
              </div>
            </div>
          ));
        })}
    </>
  )
}


export default EyeGlassPrescription;
